import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
import Glass from './glass.png'
import Post from './post.png'
import Lambo from './Lambo.png'
import Restaurant from './restaurant.png'
import { themeContext } from "../../Context";
const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{color: darkMode?'white': ''}}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >
        <SwiperSlide>
          <a href="https://goeyewear.netlify.app">
          <img src={Glass} alt=""  />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="http://zpostz.000webhostapp.com/">
          <img src={Post} alt="" />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://lamboclone.netlify.app">
          <img src={Lambo} alt="" />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://feedresto.netlify.app">
          <img src={Restaurant} alt="" />
          </a>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;